import { render, staticRenderFns } from "./adminInspectionTaskList.vue?vue&type=template&id=3a53b134&scoped=true"
import script from "./adminInspectionTaskList.vue?vue&type=script&lang=js"
export * from "./adminInspectionTaskList.vue?vue&type=script&lang=js"
import style0 from "./adminInspectionTaskList.vue?vue&type=style&index=0&id=3a53b134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53b134",
  null
  
)

export default component.exports